import React, {Component} from "react";
import {Form, Input } from 'antd';
import NHFormItem from '../common/NHFormItem';
import css from './index.css';

/**
 * 班级QQ管理编辑表单
 * @author liudongbin
 * @date 2021年8月21日 13点36分
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const {initFormData} = this.props;
        
        return (
            <div>
                <Form layout="horizontal">
                    <div style={{display:'none'}} >
                        <NHFormItem label="主键" id={"pkid"}
                                    form={this.props.form}  initialValue={initFormData.PKID} >
                            <Input  />
                        </NHFormItem>
                    </div>

                    <NHFormItem label="校区" id={"xqmc"}
                                form={this.props.form}  initialValue={initFormData.XQMC ? initFormData.XQMC :""}>
                        <div>&nbsp;&nbsp;&nbsp;{initFormData.XQMC}</div>
                    </NHFormItem>
                    <NHFormItem label="学院" id={"bmmc"}
                                form={this.props.form}  initialValue={initFormData.BMMC ? initFormData.BMMC: ""}>
                        <div>&nbsp;&nbsp;&nbsp;{initFormData.BMMC}</div>
                    </NHFormItem>
                    <NHFormItem label="专业" id={"zymc"}
                                form={this.props.form}  initialValue={initFormData.ZYMC ? initFormData.ZYMC :""}>
                        <div>&nbsp;&nbsp;&nbsp;{initFormData.ZYMC}</div>
                    </NHFormItem>
                    <NHFormItem label="班级" id={"bjmc"}
                                form={this.props.form}  initialValue={initFormData.BJMC ? initFormData.BJMC : ""}>
                        <div>&nbsp;&nbsp;&nbsp;{initFormData.BJMC}</div>
                    </NHFormItem>
                    <NHFormItem label="班级QQ" id={"bjqq"}
                                form={this.props.form}  initialValue={initFormData.BJQQ ? initFormData.BJQQ : ""} required={true}>
                        <Input  />
                    </NHFormItem>
                    
                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/bjqqManage/EditForm.js